<template>
  <div class="container">
    <head-nav-bar
      title="检查报告明细"
      :fixed="true"
      @click-left="onLeftClick"
    />
    <div class="mt-header-nav">
      <div class="box">
        <cell-box style="padding: 0.3rem 0;">
          <!-- <cell-item label="订单编号：" :value="info.BillNo" /> -->
          <cell-item label="姓名：" :value="info.patientName" />
          <cell-item label="性别：" :value="info.patientSex" />
          <cell-item label="年龄：" :value="info.patientAge" />
          <cell-item label="检查所见：">
            <template #value>
              <div style="color:#888">{{ info.indication }}</div>
            </template>
          </cell-item>
          <cell-item label="诊断意见：">
            <template #value>
              <div style="color:#888">{{ info.diagnose }}</div>
            </template>
          </cell-item>

          <cell-item label="检查时间：" :value="info.examTime" />
          <cell-item label="报告医生：" :value="info.reportDoctor" />
          <cell-item label="报告时间：" :value="info.reportTime" />
          <cell-item label="审核医生：" :value="info.auditDoctor" />
          <cell-item label="审核时间：" :value="info.auditTime" />
        </cell-box>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Icon, NoticeBar } from "vant";
import { CellBox, CellItem } from "@/components/cell";

export default {
  name: "userReportInfo",
  components: {
    CellBox,
    CellItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
  },

  data() {
    return {
      Id: "",
      ReqNo: "",
      // type: "",
      info: {},
      canCancel: false,
    };
  },
  created() {
    this.Id = this.$route.query.Id;
    this.ReqNo = this.$route.query.ReqNo;
    // this.type = this.$route.query.type

    if (this.Id && this.ReqNo) {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$post("MyReport_Detail", {
        ReportId: this.Id,
        ReqNo: this.ReqNo,
      }).then(res => {
        this.info = res.data;
      });

      //this.info.CanPay = true;
    },
    onLeftClick() {
      this.$router.push({
        name: "userReportList",
        query: {
          tab: 2,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
